import { jsx as _jsx } from "react/jsx-runtime";
import { useCustomTheme } from "../../../core/design-system/CustomThemeProvider.js";
/**
 * @internal
 */
export const IconContainer = (props) => {
    const theme = useCustomTheme();
    return (_jsx("div", { style: {
            position: "relative",
            overflow: "hidden",
            display: "flex",
            justifyItems: "center",
            flexShrink: 0,
            alignItems: "center",
            padding: props.padding ?? "6px",
            borderRadius: "100%",
            border: `1px solid ${theme.colors.borderColor}`,
            ...props.style,
        }, children: props.children }));
};
//# sourceMappingURL=IconContainer.js.map